import { IconCloseCircleV2 } from '@blockchain-com/icons'
import Logo from 'assets/images/logo-blockchain.svg'
import { CeruleanButton } from 'components/Button'
import Icon from 'components/Icons/Icon'
import { androidAppStoreUrl } from 'constants/appStore'
import { actions } from 'data'
import React from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { color } from 'utils'

import { Copy as BaseCopy, Img, Wrapper } from './styles'

const Copy = styled(BaseCopy)`
  gap: 3px;

  p {
    font-weight: 600;
    line-height: 150%;
    color: ${color('text')};
  }

  small {
    font-weight: 500;
    font-size: 10px;
    line-height: 150%;
    color: ${color('muted')};
  }

  caption {
    font-weight: 500;
    line-height: 150%;
    color: ${color('text')};
  }
`

const Button = styled(CeruleanButton)`
  align-self: center;
  border-radius: 8px;
  padding: 6px 12px;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  height: unset;
`

const AndroidMobileBanner = ({ onClose }) => {
  const dispatch = useDispatch()
  return (
    <Wrapper>
      <Icon color='grey400'>
        <IconCloseCircleV2
          onClick={() => {
            dispatch(
              actions.analytics.trackEvent({
                key: 'Mobile Web Banner Closed',
                properties: {
                  mobile_os: 'ANDROID'
                }
              })
            )
            onClose()
          }}
        />
      </Icon>
      <Img src={Logo} />
      <Copy>
        <p>Blockchain Exchange</p>
        <small>Blockchain.com</small>
        <caption>GET — On the Play Store</caption>
      </Copy>
      <Button
        onClick={() => {
          dispatch(
            actions.analytics.trackEvent({
              key: 'Mobile Web Banner Clicked',
              properties: {
                mobile_os: 'ANDROID'
              }
            })
          )
          window.open(androidAppStoreUrl)
        }}
      >
        Install
      </Button>
    </Wrapper>
  )
}

export default AndroidMobileBanner
